export default "__VITE_ASSET__DqLGbSxx__"